import { csrfToken } from './csrf.js';

const handleCredentialResponse = async (response: any) => {
	const res = await fetch('/auth/google', {
		method: 'POST',
		// X-CSRF-Token is REQUIRED (UNIT-88): the unified host CSRF-protects /auth/google, and
		// this call predates the network.ts choke point that adds the header everywhere else —
		// without it every Google sign-in from a TradeVision page 403s.
		headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
		body: JSON.stringify({ credential: response.credential })
	});

	const data = await res.json();

	if (res.ok) { window.location.href = '/';  }
	else { alert("Login Failed: " + data.error); }
};

export function renderGoogleButton(elementId: string) {
	setTimeout(() => {
		// Check if the Google library is loaded
		if (window.google) {
			window.google.accounts.id.initialize({
				client_id: "954471493320-b0v52bestqdr54lr0p564he8dojbckf4.apps.googleusercontent.com",
				callback: handleCredentialResponse
			});

			window.google.accounts.id.renderButton(
				document.getElementById(elementId),
				{ theme: "outline", size: "large", type: "standard" }
			);
		}
	}, 1000);
}
